import { Load } from "../../../types/load/load";
import { LoadDto } from "../../../types/load/load-dto";

export const convertLoadDtoToLoad = (loadDto: LoadDto): Load => {
  return {
    name: loadDto.name,
    quantity: loadDto.quantity,
  };
};
